import { useAddRemoveLead } from "../features/leads/useAddRemoveLead";
import { useGetLeads } from "../hooks/useGetLeads";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";
import { Star } from "lucide-react";

function LeadsButton({ proposalId, className, searchType, ...props }) {
  const { data: leads, isError } = useGetLeads();
  const { isLoading, mutate } = useAddRemoveLead();

  if (isError) return null;
  function onLeadButtonClick() {
    const isToggled = leads.some((lead) => lead === proposalId);
    mutate({ proposalId, searchType, isToggled });
  }
  const isSaved = leads?.some((lead) => lead === proposalId);
  return (
    <Button
      variant={isSaved ? "default" : "outline"}
      onClick={onLeadButtonClick}
      disabled={isLoading}
      className={cn("gap-2 disabled:opacity-100", className)}
      {...props}
    >
      {isSaved ? (
         <Star className="fill-white" />
      ) : (
        <Star className="text-secondary-foreground" />
      )}
      {isSaved ? "Saved" : "Save"}
    </Button>
  );
}

export default LeadsButton;
